const LTDs = [
  'com',
  'ad',
  'ae',
  'com.af',
  'com.ag',
  'al',
  'am',
  'co.ao',
  'com.ar',
  'as',
  'at',
  'com.au',
  'az',
  'ba',
  'com.bd',
  'be',
  'bf',
  'bg',
  'com.bh',
  'bi',
  'bj',
  'com.bn',
  'com.bo',
  'com.br',
  'bs',
  'bt',
  'co.bw',
  'by',
  'com.bz',
  'ca',
  'cd',
  'cf',
  'cg',
  'ch',
  'ci',
  'co.ck',
  'cl',
  'cm',
  'cn',
  'com.co',
  'co.cr',
  'com.cu',
  'cv',
  'com.cy',
  'cz',
  'de',
  'dj',
  'dk',
  'dm',
  'com.do',
  'dz',
  'com.ec',
  'ee',
  'com.eg',
  'es',
  'com.et',
  'fi',
  'com.fj',
  'fm',
  'fr',
  'ga',
  'ge',
  'gg',
  'com.gh',
  'com.gi',
  'gl',
  'gm',
  'gr',
  'com.gt',
  'gy',
  'com.hk',
  'hn',
  'hr',
  'ht',
  'hu',
  'co.id',
  'ie',
  'co.il',
  'im',
  'co.in',
  'iq',
  'is',
  'it',
  'je',
  'com.jm',
  'jo',
  'co.jp',
  'co.ke',
  'com.kh',
  'ki',
  'kg',
  'co.kr',
  'com.kw',
  'kz',
  'la',
  'com.lb',
  'li',
  'lk',
  'co.ls',
  'lt',
  'lu',
  'lv',
  'com.ly',
  'co.ma',
  'md',
  'me',
  'mg',
  'mk',
  'ml',
  'com.mm',
  'mn',
  'com.mt',
  'mu',
  'mv',
  'mw',
  'com.mx',
  'com.my',
  'co.mz',
  'com.na',
  'com.ng',
  'com.ni',
  'ne',
  'nl',
  'no',
  'com.np',
  'nr',
  'nu',
  'co.nz',
  'com.om',
  'com.pa',
  'com.pe',
  'com.pg',
  'com.ph',
  'com.pk',
  'pl',
  'pn',
  'com.pr',
  'ps',
  'pt',
  'com.py',
  'com.qa',
  'ro',
  'ru',
  'rw',
  'com.sa',
  'com.sb',
  'sc',
  'se',
  'com.sg',
  'sh',
  'si',
  'sk',
  'com.sl',
  'sn',
  'so',
  'sm',
  'sr',
  'st',
  'com.sv',
  'td',
  'tg',
  'co.th',
  'com.tj',
  'tl',
  'tm',
  'tn',
  'to',
  'com.tr',
  'tt',
  'com.tw',
  'co.tz',
  'com.ua',
  'co.ug',
  'co.uk',
  'com.uy',
  'co.uz',
  'com.vc',
  'co.ve',
  'co.vi',
  'com.vn',
  'vu',
  'ws',
  'rs',
  'co.za',
  'co.zm',
  'co.zw',
  'cat',
].reduce((prev, curr) => `${prev} https://*.google.${curr}`, '');

const script = [
  'https://googletagmanager.com https://tagmanager.google.com',
  'https://*.googletagmanager.com',
  'https://www.google-analytics.com https://ssl.google-analytics.com',
  'https://www.googleadservices.com https://www.google.com',
  'https://googleads.g.doubleclick.net https://www.google.com',
].join(' ');

const style = [
  'https://googletagmanager.com https://tagmanager.google.com https://fonts.googleapis.com https://www.googletagmanager.com',
].join(' ');

const img = [
  'https://googletagmanager.com https://ssl.gstatic.com https://www.gstatic.com https://*.gstatic.com',
  'https://*.google-analytics.com https://*.googletagmanager.com',
  `https://*.analytics.google.com https://*.g.doubleclick.net https://*.google.com ${LTDs}`,
  'https://www.google-analytics.com',
  'https://googleads.g.doubleclick.net https://www.google.com https://google.com',
].join(' ');

const font = ['https://fonts.gstatic.com data:'].join(' ');

const connect = [
  'https://*.google-analytics.com https://*.analytics.google.com https://*.googletagmanager.com',
  `https://*.googletagmanager.com https://*.g.doubleclick.net https://*.google.com ${LTDs}`,
  'https://www.google-analytics.com',
].join(' ');

const frame = ['https://sgtm.stihl.com https://bid.g.doubleclick.net'].join(' ');

export { script, style, img, font, connect, frame };
